import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/shadcn/components/ui/dropdown-menu";
import { Button } from "@/shadcn/components/ui/button";
import { IoClose } from "react-icons/io5";
import { FaFilter } from "react-icons/fa6";
import { BsSortAlphaDownAlt, BsSortAlphaUpAlt, BsStars } from "react-icons/bs";
import { BiSortAlt2, BiTrendingUp } from "react-icons/bi";
import { HandCoins } from "lucide-react";

export const Item = ({ children, className, onChange }) => (
  <DropdownMenuItem
    onClick={onChange}
    className={
      className +
      " " +
      "hover:cursor-pointer flex flex-row items-center gap-x-2 pr-8 py-2 rounded-none text-base font-bold hover:bg-slate-700 focus:bg-slate-700 focus:text-white"
    }
  >
    {children}
  </DropdownMenuItem>
);
export const Sort = ({ state, onChange }) => {
  return (
    <DropdownMenu className="dark">
      <DropdownMenuTrigger className="flex flex-row gap-x-2 text-lg leading-tight px-4 py-2 items-center bg-gray-200 hover:bg-gray-300 active:shadow-lg transition duration-150 ease-in-out uppercase text-sp text-black rounded-full">
        <BiSortAlt2 className="w-6 h-6" />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="font-BreezeHeader bg-slate-800 text-white border-0 drop-shadow-xl rounded-2xl py-2">
        <Item onChange={() => onChange({ ...state, sort: "newest-first" })}>
          <BsSortAlphaDownAlt className="text-2xl" />
          Newest
        </Item>
        <Item onChange={() => onChange({ ...state, sort: "oldest-first" })}>
          <BsSortAlphaUpAlt className="text-2xl" />
          Oldest
        </Item>
        <Item onChange={() => onChange({ ...state, sort: "most-views" })}>
          <BsStars className="text-2xl" />
          Popular
        </Item>
        <Item onChange={() => onChange({ ...state, sort: "least-views" })}>
          <HandCoins className="text-2xl" />
          Rising
        </Item>
        {false && (
          <Item onChange={() => onChange({ ...state, sort: "trending" })}>
            <BiTrendingUp className="text-2xl" />
            Trending
          </Item>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
